export const testimonials = [
  {
    name: "hellokrish",
    country: "United States",
    description:
      "Its truly a great experience learning from him. Very patient and intelligent and easy to understand on all sessions. Looking forward to learn more!",
  },
  {
    name: "siddidumeshmand",
    country: "Singapore",
    description:
      "I had 2 hours' worth of classes with him, they were good and I plan to buy more. Every second is utilized and he knows what is easy to figure out and what the student can do themselves. Most of the lesson time is spent on tricky parts and none is wasted. Questions are answered swiftly and the lesson is at a fast but understandable pace. Would recommend people who have problems, questions or any doubts regarding react native.",
  },
  {
    name: "marcoandrept",
    country: "Portugal",
    description:
      "Stellar developer. The whole experience was great. Really helpful and helped me a lot regarding my case. Highly recomended.",
  },

  {
    name: "bwpbruce",
    country: "Norway",
    description:
      "Cleared up some confusion I was having with understanding Javascript. After one session with Jeejo I was able to understand what was confusing me. Really it was just one thing but I don't think I would have been able to understand it without this session. Good job Jeejo.",
  },

  {
    name: "imaginestudioai",
    country: "United States",
    description:
      "It was great! This developer makes the process smooth and expeditious. Jeejo simplifies the language complexities in way that is clear, concise, and memorable. He's definitely an experienced professional. Highly Recommend!",
  },
  {
    name: "truce_r",
    country: "Canada",
    description:
      "TOP TIER! He is a wonderful developer! great communication skills and is able to do exactly what you describe. He has been a massive help with our project and I highly recommend him to anyone!",
  },
  {
    name: "boulmpos",
    country: "Greece",
    description:
      "Jeejo is a very smart and talented developer. He helped me solve my issue very fast and in a very professional manner. I will definitely use his services again since I am very impressed of the way he works! Thanks again",
  },
  {
    name: "samiryep",
    country: "United Kingdom",
    description:
      "Absolutely brilliant! He solved the problem I had before our call, explained the solution in a live session and then shared the code with me afterwards! Could not ask for a better service. Thanks so much! 100% recommended and will definitely be using again!",
  },
  {
    name: "aloe_drink",
    country: "United States",
    description:
      "He helped me better my understanding of React concepts by guiding me through step by step as well as explaining everything he did thoroughly. Highly recommend.",
  },
];
